import {
  Image,
  SimpleGrid,
  Container,
  Heading,
  Card,
  CardBody,
  Text,
  Flex,
  Box,
} from "@chakra-ui/react";
import ImgTeam from "../images/team.svg";
import { useRef } from "react";
import { useInView } from "framer-motion";

const AboutPage = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <Container
      maxW="container.xl"
      pt="4rem"
      id="about"
      justifyContent="center"
      px={8}
      css={{ scrollMargin: "4rem" }}
      ref={ref}
    >
      <Heading
        as="h1"
        size="3xl"
        noOfLines={4}
        bgGradient="linear(to-r, #7928CA, #FB3640)"
        bgClip="text"
        textAlign="center"
        pb={10}
        style={{
          transform: isInView ? "none" : "translateY(100px)",
          opacity: isInView ? 1 : 0,
          transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}
      >
        About
      </Heading>
      <SimpleGrid spacing={10}>
        <Card
          boxShadow="md"
          style={{
            transform: isInView ? "none" : "translateY(200px)",
            opacity: isInView ? 1 : 0,
            transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <CardBody>
            <Flex
              justifyContent="center"
              alignItems="center"
              direction="column"
              gap={10}
            >
              <Box w="50%">
                <Image alignSelf="center" src={ImgTeam} alt="ZenSpyder Team" />
              </Box>
              <Box p={[0, 0, 5, 5]}>
                <Text color="gray.500" lineHeight={8}>
                  &emsp;&emsp;
                  <mark
                    style={{
                      background: "transparent",
                      color: "#FB3640",
                      fontWeight: "600",
                    }}
                  >
                    ZenSpyder Private Ltd
                  </mark>
                  {"  "}&nbsp; is a emerging software development company with a
                  focus on delivering high-quality software solutions. Our team
                  consists of experienced developers, designers, and project
                  managers who are dedicated to delivering exceptional results.
                  <br />
                  <br /> &emsp;&emsp;We specialize in developing custom software
                  applications for businesses, including ERP Solutions,
                  Healthcare Solutions, Mobile Apps, and Desktop applications.
                  We use the latest technologies and methodologies to ensure
                  that our solutions are efficient, scalable, and secure. Our
                  approach to software development is collaborative and
                  customer-focused, ensuring that the end product meets the
                  specific needs of our clients.
                  <br />
                  <br /> &emsp;&emsp;We have a strong commitment to meeting
                  project timelines and delivering high-quality results, on-time
                  and within budget. Our portfolio of work showcases a wide
                  range of industries and applications, demonstrating our
                  versatility and expertise. Our clients appreciate our
                  transparent and communicative approach, which helps us to
                  build long-lasting relationships. We believe that software
                  should be accessible to everyone and strive to deliver
                  solutions that are user-friendly and intuitive. Partner with
                  us to bring your vision for software to life and help
                  transform the way you do business.
                </Text>
              </Box>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Container>
  );
};
export default AboutPage;
